import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem, getResetByTag } from './../../../styles';
var defaultStyles = /*#__PURE__*/css("display:inline-grid;grid-column-gap:", rem(50), ";grid-template-columns:repeat(2, 1fr);" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));

/** Export to use as selector in other component's styles. */
var resetStyles = getResetByTag('div');
var StyledCalendarButtonContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1uwotcp0"
} : {
  target: "e1uwotcp0",
  label: "StyledCalendarButtonContainer"
})(resetStyles, defaultStyles);
export default StyledCalendarButtonContainer;